document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  const items = carousel.querySelectorAll(".product-item");
  const gap = parseInt(getComputedStyle(carousel).gap) || 0; // gapの値を取得
  let currentIndex = 0;

  // アイテム幅を取得する関数
  function getItemWidth() {
    return items[0].offsetWidth + gap; // アイテム幅 + gap
  }

  // 表示アイテム数を取得する関数
  function getVisibleItems() {
    if (window.innerWidth <= 520) {
      return 1; // 520px以下: 1アイテム表示
    } else if (window.innerWidth <= 768) {
      return 2; // 768px以下: 2アイテム表示
    } else {
      return 4; // 768px以上: 4アイテム表示
    }
  }

  // 次へ進む関数
  function nextSlide() {
    if (currentIndex < items.length - getVisibleItems()) {
      currentIndex++;
    } else {
      currentIndex = 0; // 最後に到達したら最初に戻る
    }
    const moveDistance = getItemWidth() * currentIndex;
    carousel.style.transform = `translateX(-${moveDistance}px)`;
  }

  // 前に戻る関数
  function prevSlide() {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = items.length - getVisibleItems(); // 最初に戻ったら最後に移動
    }
    const moveDistance = getItemWidth() * currentIndex;
    carousel.style.transform = `translateX(-${moveDistance}px)`;
  }

  // ボタンのイベントリスナー
  document.querySelector(".carousel-next").addEventListener("click", nextSlide);
  document.querySelector(".carousel-prev").addEventListener("click", prevSlide);

  // ウィンドウリサイズ時にリセット
  window.addEventListener("resize", () => {
    currentIndex = 0; // リセットして最初に戻す
    carousel.style.transform = `translateX(0px)`;
  });
});